import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import iconExcellent from "../assets/mood/icon-excellent.png";
import iconGood from "../assets/mood/icon-good.png";
import iconOkay from "../assets/mood/icon-okey.png";
import iconSad from "../assets/mood/icon-sad.png";
import iconTerrible from "../assets/mood/icon-terrible.png";
import "./Theme.css";
import "./MoodTracking.css";

const MOODS = [
  { key: "excellent", icon: iconExcellent, labelKey: "moodTracking.excellent" },
  { key: "good", icon: iconGood, labelKey: "moodTracking.good" },
  { key: "okay", icon: iconOkay, labelKey: "moodTracking.okay" },
  { key: "sad", icon: iconSad, labelKey: "moodTracking.sad" },
  { key: "terrible", icon: iconTerrible, labelKey: "moodTracking.terrible" },
];

const MoodTracking = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectedMood, setSelectedMood] = useState("");
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const uuid = urlParams.get("uuid") || "";
  const goqiiUserId = getGoqiiUserId();
  const nonce = urlParams.get("nonce") || "";
  const apiKey = urlParams.get("apiKey") || "";
  const signature = urlParams.get("signature") || "";
  const goqiiAccessToken = urlParams.get("goqiiAccessToken") || "";

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    document.title = t("moodTracking.pageTitle", "Emotional Wellbeing");
  }, [theme, lang, t]);

  const handleSelect = (mood) => {
    setSelectedMood(mood);
    const qs = `uuid=${uuid}&goqiiuserid=${goqiiUserId}&nonce=${nonce}&apiKey=${apiKey}&signature=${signature}&goqiiAccessToken=${goqiiAccessToken}`;
    navigate(`/emotional-mood-today?selectedMood=${mood}&${qs}&theme=${theme}&lang=${lang}`);
  };

  const [firstMood, ...restMoods] = MOODS;

  const renderMoodCard = ({ key, icon, labelKey }) => (
    <button
      key={key}
      type="button"
      className={`mood-btn${selectedMood === key ? " mood-btn-active" : ""}`}
      onClick={() => handleSelect(key)}
    >
      <img src={icon} className="mood-icon" alt={t(labelKey)} />
      <span className="mood-label">{t(labelKey)}</span>
    </button>
  );

  return (
    <section className="mood-page">
      <h1 className="mood-title">{t("moodTracking.pageTitle", "Emotional Wellbeing")}</h1>
      <p className="mood-instruction">{t("moodTracking.title")}</p>
      <div className="mood-featured">{renderMoodCard(firstMood)}</div>
      <div className="mood-grid">{restMoods.map(renderMoodCard)}</div>
    </section>
  );
};

export default MoodTracking;
